import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { PAYMENT_METHODS } from './Constants';

export const getPaymentMethodNameByKey = (key) => {
    return PAYMENT_METHODS.find((item) => item.key === key).value;
};

// Mobile fields are stored digits-only with the country code prefixed, no "+" (e.g.
// "923001234567") — format that into something readable (e.g. "+92 300 1234567").
// Falls back to the raw stored string if it can't be parsed, so legacy/malformed data
// never crashes a table row.
export const formatMobileDisplay = (mobile) => {
    if (!mobile) return mobile;
    const parsed = parsePhoneNumberFromString(`+${mobile}`);
    return parsed ? parsed.formatInternational() : mobile;
};

// Same digits-only-with-country-code convention as above — used by ValidationSchemas.js
// and any inline (non-Yup) validity checks.
export const isValidMobile = (mobile) => {
    const parsed = parsePhoneNumberFromString(`+${mobile}`);
    return Boolean(parsed?.isValid());
};

export const capitalize = (str) => {
    return str.replace(/\b(\w)/g, (s) => s.toUpperCase());
};

// Optional `theme` makes the result mode-aware. Without it, falls back to the
// original light-only behavior so any other caller keeps working.
export const getColorByStatus = (row, theme) => {
    const isDeleted = row?.deleted === true || row?.status === 'deleted';
    if (isDeleted) {
        return theme?.palette?.mode === 'dark' ? '#ef4444' : 'red';
    }
    return theme?.palette?.text?.primary || 'black';
}
